import { useCallback, useRef } from 'react';

/** Only calls callback during activation (with last sent args), and afterwards */
function useDeferredCallback(callback) {
  const lastArgs = useRef(null);
  const sendInactive = useCallback((...args) => {
    lastArgs.current = args;
  }, []);
  const sendRef = useRef(sendInactive);

  const activate = useCallback(() => {
    // Don't reactivate
    if (sendRef.current !== sendInactive) {
      return;
    }

    if (lastArgs.current === null) {
      return;
    }

    callback(...lastArgs.current);
    sendRef.current = function passThrough(...args) {
      callback(...args);
    };
  }, [callback, sendInactive]);

  return [sendRef.current, activate];
}

export { useDeferredCallback };
